
export function myUrlDecode(myString){
    const textArea = document.createElement('textarea');
    textArea.innerHTML = myString  //.post is OSSN wall post specific JSON field name, it's content is HTML encoded (so we can use it to carry json data as a string with double quote encoded)
    const decodedString = textArea.value;
    return decodedString
}



export function myUrlEncode(myString){
    const textArea = document.createElement('textarea');
    textArea.innerText = myString;
    const ossn_post_text_encoded = textArea.innerHTML;
    return ossn_post_text_encoded
}


export function myIsObject(value) {
    return typeof value === 'object' 
           && value !== null 
           && !Array.isArray(value)
           && !(value instanceof Date)
           && !(value instanceof RegExp)
           && !(value instanceof Map)
         //  && !(value instanceof Set)[1][5]
}

export function parseIBGAttendanceFromOSSN(postList) {
    const textArea = document.createElement('textarea');
    const parsedList = postList.map(
            (item)=> {

                let post_content = JSON.parse(item['post']['description'])

                textArea.innerHTML = post_content.post;  //.post is OSSN wall post specific JSON field name, it's content is HTML encoded (so we can use it to carry json data as a string with double quote encoded)
                const decodedString_obsolete = textArea.value;

                const decodedString   = myUrlDecode(post_content.post)
                let post_content_json = JSON.parse(decodedString)

                if( myIsObject(post_content_json) ){
                    const newItem = {...post_content_json,
                                          '$id':            item['post']['poster_guid'],
                                          'guid':           item['post']['guid'],
                                          'PostContent':    item['post']['description'],
                                          'Text':           item['text'],
                                          'User':           item['user']['email'],
                                          'UserId':         item['user']['guid'],
                                    }
                     return newItem
                }else{
                    alert("Unexpected error in parsing OSSN data in parseIBGAttendanceFromOSSN(). Contact developer or admin." )
                    return
                }
            }
        )
    return parsedList
}
